/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'goal-actions.goal-content-about.edit-description-error-description':
    'Algo deu errado, tente de novo em alguns minutos.',
  'goal-content.goal-about-content.description-edit-button': 'Editar',
  'goal-content.goal-about-content.description-title': 'Descrição',
  'goal-content.goal-about-content.placeholder-description':
    'Descreva com poucas palavras por que essa meta é importante e como o sucesso é medido, para que você possa oferecer aos seguidores um entendimento comum.',
  'goal-content.goal-content-about.edit-description-error-title': 'Não foi possível editar a descrição da meta',
  'goal-content.goal-content-update-date.edited': '(editado)',
  'goal-content.goal-content-update-date.edited-tooltip': 'Editado em {date}',
  'goal-content.goal-content-update-date.last-edited-by': '(editado pela última vez por {name})',
  'goal-content.goal-content-updates.add-update': 'Adicionar atualização',
  'goal-content.goal-content-updates.archived': 'Arquivado',
  'goal-content.goal-content-updates.at-risk': 'Em risco',
  'goal-content.goal-content-updates.cancelled': 'Cancelado',
  'goal-content.goal-content-updates.completed': 'Concluído 🎉',
  'goal-content.goal-content-updates.date-changed': 'Data alterada',
  'goal-content.goal-content-updates.edit-update': 'Editar',
  "goal-content.goal-content-updates.for-date'": 'para {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': 'Última atualização',
  'goal-content.goal-content-updates.missed-update-message': 'Nenhuma atualização foi publicada',
  'goal-content.goal-content-updates.new-due-date': 'Nova data de entrega',
  'goal-content.goal-content-updates.new-state': 'Novo estado',
  'goal-content.goal-content-updates.no-updates-description': 'Ainda não há atualizações para essa meta.',
  'goal-content.goal-content-updates.off-track': 'Fora dos trilhos',
  'goal-content.goal-content-updates.old-due-date': 'Data de entrega antiga',
  'goal-content.goal-content-updates.old-state': 'Estado antigo',
  'goal-content.goal-content-updates.on-track': 'Nos trilhos',
  'goal-content.goal-content-updates.paused': 'Pausado',
  'goal-content.goal-content-updates.pending': 'Pendente',
  'goal-content.goal-content-updates.previous-updates-title': 'Atualizações anteriores',
  'goal-content.goal-content-updates.share-update': 'Compartilhar',
  'goal-content.goal-content-updates.status-changed': 'Status alterado',
  'goal-content.goal-content-updates.write-update-button': 'Escreva uma atualização',
  'goal-content.goal-update-composer.modal-title': 'Publicar atualização',
  'goal-content.goal-update-composer.post-button-label': 'Publicar atualização',
};
